// This file is generated, do not edit!
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import { type DatevAuth, DatevAuthCode } from "../../api";
import { useGetApi } from "../client";
import { useCallback } from "react";

export function usePostDatevAuth(): (
  requestBody: DatevAuthCode
) => Promise<DatevAuth> {
  const getAPI = useGetApi();
  return useCallback(
    async (requestBody) =>
      (await getAPI()).externesysteme.postDatevAuth({ requestBody }),
    [getAPI]
  );
}
